import type { SVGProps } from 'react';

function LinkedinIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
      <rect width="4" height="12" x="2" y="9" />
      <circle cx="4" cy="4" r="2" />
    </svg>
  );
}

const SOCIAL_LINKS = [
  {
    href: 'https://www.linkedin.com/company/asociaci%C3%B3n-peruana-de-entidades-prestadoras-de-salud/',
    label: 'LinkedIn',
    Icon: LinkedinIcon,
  },
];

export function Footer(): React.ReactElement {
  const year = new Date().getFullYear();
  return (
    <footer className="from-muted/30 to-background bg-linear-to-br py-8 md:py-10 lg:py-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-12">
        <div className="lg:hidden">
          <div className="mb-8 text-center">
            <h3 className="from-foreground to-muted-foreground bg-linear-to-r bg-clip-text text-2xl font-bold text-transparent">
              APEPS
            </h3>
          </div>

          <div className="mb-6">
            <p className="text-muted-foreground mb-4 text-center text-xs tracking-wider uppercase">
              Síguenos
            </p>
            <div className="flex justify-center space-x-4">
              {SOCIAL_LINKS.map(({ href, label, Icon }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="group bg-card shadow-medium hover:border-primary/30 hover:shadow-strong relative flex h-12 w-12 items-center justify-center rounded-full border transition-all duration-300 hover:scale-110"
                >
                  <Icon className="text-muted-foreground group-hover:text-primary h-5 w-5 transition-colors" />
                </a>
              ))}
            </div>
          </div>

          <div className="border-t pt-6 text-center">
            <p className="text-muted-foreground text-xs">
              © {year} APEPS. Todos los derechos reservados.
            </p>
          </div>
        </div>

        <div className="hidden lg:block">
          <div className="flex items-center justify-between gap-8">
            <div>
              <h3 className="text-foreground text-xl font-bold">APEPS</h3>
            </div>

            <div className="flex items-center gap-8">
              <div className="flex space-x-4">
                {SOCIAL_LINKS.map(({ href, label, Icon }) => (
                  <a
                    key={label}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={label}
                    className="text-muted-foreground hover:text-foreground transition-all duration-200 hover:scale-110"
                  >
                    <Icon className="h-5 w-5" />
                  </a>
                ))}
              </div>

              <p className="text-muted-foreground text-xs">© {year} APEPS</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
